(function () {
  function optimizeAmazonImage(img) {
    if (
      img &&
      img.tagName === 'IMG' &&
      img.src &&
      img.src.includes('m.media-amazon.com')
    ) {
      img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'low';
    }
  }

  function scanAmazonImages(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.tagName === 'IMG') {
      optimizeAmazonImage(root);
      return;
    }

    const images = root.querySelectorAll(
      'img[src*="m.media-amazon.com"]'
    );

    images.forEach(optimizeAmazonImage);
  }

  function startOptimization() {
    document
      .querySelectorAll('img[src*="m.media-amazon.com"]')
      .forEach(optimizeAmazonImage);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          scanAmazonImages(node);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Rivyo normally initializes shortly after page load.
    // Stop watching the entire DOM after 8 seconds.
    setTimeout(() => {
      observer.disconnect();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startOptimization,
      { once: true }
    );
  } else {
    startOptimization();
  }
})();